export default {
  namespaced: true,
  state: {
    navbarHeight: 0,
  },
  mutations: {
    setNavbarHeight(state, height) {
      state.navbarHeight = height - 70;
    },
  },
  getters: {
    getNavbarHeight(state) {
      return `calc(10.1rem + ${state.navbarHeight}px)`;
      if (state.navbarHeight > 78 || state.navbarHeight == 0) {
        return `calc(15.1rem + ${state.navbarHeight}px)`;
      } else {
        return `5.1rem`;
      }
    },
  },
  actions: {},
};
